import amapi from '@/api/amapi'

const initialState = () => ({
  invoices: [],
  invoice: {},
  contact: {},
  payments: []
})

const state = initialState

const getters = {
  invoices: state => state.invoices,
  invoice: state => state.invoice,
  contact: state => state.contact,
  payments: state => state.payments,
}

const mutations = {
  POPULATE_INVOICES (state, invoices) {
    state.invoices = invoices
  },
  POPULATE_INVOICE (state, { invoice, contact, payments }) {
    state.invoice = invoice
    state.contact = contact
    if (payments) {
      console.log('tets')
      state.payments = payments
    }
  },

  CLEAR_BILLING_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async getInvoices ({ commit }) {
    try {
      const { invoices } = await amapi.makecall('invoicelist')
      commit('POPULATE_INVOICES', invoices)
    } catch (e) {
      throw e
    }
  },
  async getInvoice ({ commit }, id) {
    try {
      const { invoice, contact, payments } = await amapi.makecall('invoice', id)
      commit('POPULATE_INVOICE', { invoice, contact, payments })
    } catch (e) {
      throw e
    }
  },
  async payInvoice ({ commit }, data) {
    try {
      return await amapi.makecall('invoice_payment', data)
    } catch (e) {
      throw e
    }
  },
  async domainTransferPay (_, data) {
    try {
      return await amapi.makecall('domaintransfer_pay', data)
    } catch (e) {
      throw e
    }
  },
}
const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
